import { FC, useId } from "react";

import Stack from "@mui/material/Stack";

import { useInitialNewsletter } from "../Context/InitialNewsletterContext";

import { NewsletterMirrorFrame } from "@/common/components/NewsletterMirrorFrame/NewsletterMirrorFrame";
import { trpc } from "@/common/helpers/trpc";
import { FormDrawer } from "@/forms-design-system/FormDrawer/FormDrawer";
import { FormTypography } from "@/forms-design-system/FormTypography";

const EMAIL_DRAWER_WIDTH = 700;

interface NewsletterDrawerProps {
  organizationId: string;
  newsletterId: string | null;
  onClose: () => void;
}

export const NewsletterDrawer: FC<NewsletterDrawerProps> = ({ organizationId, newsletterId, onClose }) => {
  const titleId = useId();
  const initialNewsletter = useInitialNewsletter();
  const { data: newsletter } = trpc.getOrganizationPageNewsletter.useQuery(
    { organizationIdOrUrlPath: organizationId, emailDeliveryId: newsletterId ?? "" },
    {
      enabled: Boolean(newsletterId),
      initialData: initialNewsletter?.id === newsletterId ? initialNewsletter : undefined,
    }
  );

  return (
    <FormDrawer open={Boolean(newsletterId)} onClose={onClose} width={EMAIL_DRAWER_WIDTH} aria-labelledby={titleId}>
      {newsletterId && newsletter && (
        <Stack gap={2} sx={{ height: "100%" }}>
          <FormTypography id={titleId} variant="h6" vibe="intense">
            {newsletter.subject}
          </FormTypography>
          <Stack sx={{ flex: 1, minHeight: 0 }}>
            <NewsletterMirrorFrame html={newsletter.html} title={newsletter.subject} />
          </Stack>
        </Stack>
      )}
    </FormDrawer>
  );
};
